<template>
  <ListQuestions :client_name="client_name" :question_types="question_types" />
</template>
<script>
import ListQuestions from "@/components/questionnaire/ListQuestions.vue";

import axios from "axios";
import $ from "jquery";

export default {
  name: "AstrologyQuestionnaire",
  components: { ListQuestions },

  data() {
    return {
      client_name: "AV",
      
       question_types: [
        { label: "Multi choice", value: "multichoice" },
        { label: "One choice", value: "onechoice" },
        { label: "Text", value: "text" },
        { label: "Audio", value: "audio" },
      ],
    };
  },
  computed: {},
  watch() {},
  mounted() {},
  created() {},
  methods: {},
};
</script>



// WEBPACK FOOTER //
// src/components/astrology_ventures/admin/Questionnaire.vue